import React, { useRef, useEffect, useState } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"
import { motion, useAnimation } from "framer-motion"
import { useInView } from 'react-intersection-observer';

import ContentWrapper from "styles/contentWrapper"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import * as Icons from '@fortawesome/free-solid-svg-icons';

const iconList = Object
  .keys(Icons)
  .filter(key => key !== "fas" && key !== "prefix" )
  .map(icon => Icons[icon])

library.add(...iconList)

const spot1 = 'https://hrflow-ai.imgix.net/backgrounds/spot.svg'
const spot2 = 'https://hrflow-ai.imgix.net/backgrounds/mini-spot.svg'
const spot3 = 'https://hrflow-ai.imgix.net/backgrounds/circle-spot.svg'

const filters = [
  {
    title: "Sources",
    type: "source",
    items: ["Website", "ATS", "HRIS", "HRMS", "CRM", "Job boards", "Emails", "Social Networks", "CV libraries", "Agencies", "LMS", "ISP", "Intranet"],
  },
  {
    title: "Boards",
    type: "board",
    items: ["ATS",  "HRIS",  "CRM",  "Website",  "API",  "Rss feed",  "HRMS",  "LMS",  "ISP",  "Intranet"],
  },
  {
    title: "Artificial intelligence",
    type: "ai",
    items: ["Profile Parsing", "Profile Searching", "Profile Embedding", "Profile Scoring", "Profile Upskilling", "Job Parsing", "Job Searching", "Job Upskilling", "Job Scoring", "Job Parsing", "Profile Tagging"],
  },
  {
    title: "Destinations",
    type: "destination",
    items: ["ATS", "HRIS", "CRM", "HRMS", "Website", "Embedded UI", "Newsletter"]
  }
]

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;
  background: linear-gradient(357.83deg, rgba(0, 207, 225, 0) 1.57%, rgba(0, 207, 225, .06) 40.64%, rgba(255, 255, 255, .02) 99.79%);
    mix-blend-mode: normal;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
    background-image: url(${spot1}), url(${spot2}), url(${spot3});
    background-size: 16rem 22.5rem, 1.5rem 2rem, 2.55rem 2.55rem;
    background-position: 5% 45%, 5% 27%, 98% 98%;
    background-repeat: no-repeat;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
  }
`

const StyledWrapper = styled.div`
  display: flex;
`

const StyledFilters = styled.div`
  width: 20rem;
  min-width: 20rem;
  .filter {
    .label {
      font-weight: 600;
    }
    ul {
      list-style: none;
      font-family: 'plain-thin';
      font-size: 0.9rem;
      line-height: 1.8rem;
      padding-left: 0.5rem;
      li {
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }
`


const StyledItems = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
  grid-auto-rows: minmax(261px, auto);
  justify-items: center;
  width: -webkit-fill-available;
  .item {
    box-shadow: 0 1rem 2.5rem rgb(132 156 156 / 15%);
    padding: 2rem 1.5rem;
    background: white;
    border-radius: 0.3rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-weight: 600;
      font-size: 1.2rem;
      line-height: 1.5rem;
      margin-bottom: 1.5rem;
    }
    .description {
      font-family: 'plain-thin';
      font-size: 1rem;
      line-height: 1.5rem;
      margin-bottom: 1.5rem;
    }
    .label {
      font-size: 1rem;
      font-family: ${({ theme }) => theme.fonts.plainLight};
    }
    .ucecases {
      list-style: none;
      margin: 0;
      padding: 0;
      margin-bottom: 1.5rem;
      .useCase {
        span {
          font-size: 1rem;
          font-family: ${({ theme }) => theme.fonts.plainLight};
          svg {
            margin-right: 0.5rem;
            opacity: 0.4;
          }
        }
      }
    }
    .tags {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      margin: 0.5rem 0;
      align-items: center;
      flex-wrap: wrap;
      .tag {
        padding: 4px 8px;
        font-size: 12px;
        line-height: 16px;
        color: #737a96;
        border: 0;
        border-radius: 4px;
        background: rgba(213,218,240,0.4);
        white-space: nowrap;
        margin: 0.3rem;
      }
    /*   .tag.advanced {
        color: #038276;
        background: rgba(0,150,136,0.22);
      } */
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-auto-rows: auto;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    grid-template-columns: repeat(1, 1fr);
    .item {
      max-width: 90%;
      padding: 1rem;
    }
    grid-gap: 4rem;
  }
`
const StyledTags = styled.div`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  li {
    color: #038276;
    background: rgba(0,150,136,0.22);
    padding: 6px 8px;
    font-size: 13px;
    line-height: 18px;
    border: 0;
    border-radius: 4px;
    white-space: nowrap;
    margin: 0.3rem;
    .icon {
      margin-left: 0.8rem;
      cursor: pointer;
    }
    .icon-right {
      margin-right: 0.3rem;
    }
  }
`

const Process = ({ content }) => {
  const { exports, frontmatter } = content[0].node
  const { usecases } = exports
  const [filtersState, setFiltersState] = useState([])
  const [useCasesState, setUseCasesState] = useState(usecases)

  // Only trigger animations if the intro is done or disabled
  const iControls = useAnimation()
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  useEffect(() => {
    const sequence = async () => {
      if (inView) {
        await iControls.start(i => ({
          opacity: 1,
          scaleY: 1,
          transition: { delay: i * 0.05 },
        }))
      }
    }
    sequence()
  }, [inView, iControls])


  function containsObject(obj, list) {
    var ind = -1
    list.every((elem, index) => {
      if(elem.type === obj.type && elem.value === obj.value) {
        ind = index
        return false
      }
      return true
    })
    return ind
  }

  const updateFiltersState = value => {
    let newFilters = [...filtersState]
    const index = containsObject(value, newFilters)
    if( index === -1) {
      newFilters.push(value)
    } else {
      newFilters.splice(index, 1)
    }
    setFiltersState(newFilters)
    if(newFilters.length > 0) {
      let result = usecases.filter(newCase => {
        let bol = false
        newCase.cases.forEach(element => {
          newFilters.forEach(filter => {
            if(filter.type === element.type && element.tags.indexOf(filter.value) !== -1) {
              bol = true
            }
          })
        });
        return bol
      })
      setUseCasesState(result)
    } else {
      setUseCasesState(usecases)
    }
    
  }
  return (
    <StyledSection id="layers">
      <StyledContentWrapper>
        <h2 className="section-title">{frontmatter.title}</h2>
        <StyledWrapper>
          <StyledFilters>
            {filters.map(({title, type, items}, index) => {
              return (
                <div className="filter" key={index}>
                  <div className="label">{title}</div>
                  <ul>
                    {items.map((item, key) => {
                      return (
                        <li key={key} onClick={() => updateFiltersState({type: type, value: item})}>{item}</li>
                      )
                    })}
                  </ul>
                </div>
              )
            })}
          </StyledFilters>
          <div>
            <StyledTags>
              {filtersState.map(filter => {
                let icon = "source"
                switch(filter.type) {
                  case "source":
                    icon = "address-book"
                    break;
                  case "board":
                    icon = "briefcase"
                    break;
                  case "ai":
                    icon = "brain"
                    break;
                  case "destination":
                    icon = "rocket"
                    break;
                  default:
                    icon = "source"
                  }
                return (
                  <li><FontAwesomeIcon className="icon-right" icon={icon} />{filter.value}<FontAwesomeIcon className="icon"  icon="times" onClick={() => updateFiltersState({type: filter.type, value: filter.value})} /></li>
                )
              })}
            </StyledTags>
            <StyledItems ref={ref}>
              {useCasesState.map(({ name, description, cases, advancedCase }, key) => {
                return (
                  <motion.div
                    className="item"
                    key={key}
                    custom={key}
                    initial={{ opacity: 0, scaleY: 0 }}
                    animate={iControls}
                  >
                    <div>
                      <div className="title">{name}</div>
                      <ul className="ucecases">
                        {cases.map(({name, tags, icon}, key) => {
                          return (
                            <li className="useCase">
                              <span><FontAwesomeIcon className="icon-right" icon={icon} />{name}:</span>
                              <ul className="tags">
                                {tags.map(tag => {
                                  return (
                                    <li className="tag">{tag}</li>
                                  )
                                })}
                              </ul>
                            </li>
                          )
                        })}
                      </ul>
                      <div className="description">{description}</div>
                    </div>
                    <div>
                      <div className="label">{advancedCase.name}</div>
                      <ul className="tags">
                        {advancedCase.tags.map(tag => {
                          return (
                            <li className="tag advanced">{tag}</li>
                          )
                        })}
                      </ul>
                    </div>
                  </motion.div>
                )
              })}
            </StyledItems>
          </div>
        </StyledWrapper>
      </StyledContentWrapper>
    </StyledSection>
  )
}

Process.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        exports: PropTypes.shape({
          items: PropTypes.array.isRequired,
        }).isRequired,
        frontmatter: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export default Process
